var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"v-icon notranslate material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }